import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { getUrlParams } from '../utils/get-url-params';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private urlToken: string | null = null;
  private urlInstance = '';
  private urlLanguage = '';
  private urlGameId: string | null = null;

  private _isMobile = new BehaviorSubject<boolean>(false);
  readonly isMobile$ = this._isMobile.asObservable();

  init(): void {
    const { token, instance, language, gameId } = getUrlParams();
    this.urlToken = token;
    this.urlInstance = instance;
    this.urlLanguage = language;
    this.urlGameId = gameId;
  }

  getUrlToken(): string | null {
    return this.urlToken;
  }

  getUrlInstance(): string {
    return this.urlInstance;
  }

  getUrlLanguage(): string {
    return this.urlLanguage;
  }

  getUrlGameId(): string | null {
    return this.urlGameId;
  }

  setIsMobile(isMobile: boolean): void {
    this._isMobile.next(isMobile);
  }
}
